import React, { useState, useEffect, useContext } from "react";
import { DataUserContext, NavigateButtonsContext } from "../../../Criare";

import { Hero, Next, Back, LinearGradient } from "../../../../components";

import {
  Container,
  Section,
  Gallery,
  GalleryItem,
  NavigateButtons,
} from "./styles";
import { Icon3 } from "../../../../assets/criare";
import { ThemeContext, DefaultTheme } from "styled-components";
import { sendSelectedImages } from "../../../../services/data-service/api";
import eventTypes from "../../../../events/event-types.const";
import HistoryPages from "../../../../events";
import can from "../../../../utils/can";

interface IGalleryItem {
  id: number;
  url: string;
}

const Question02: React.FC = () => {
  const [GALLERY_COLUMN1, setGALLERY_COLUMN1] = useState<IGalleryItem[]>([]);
  const [GALLERY_COLUMN2, setGALLERY_COLUMN2] = useState<IGalleryItem[]>([]);
  const _theme = useContext(ThemeContext);
  const [theme, setTheme] = useState({} as DefaultTheme);

  useEffect(() => {
    if (_theme.steps) {
      setTheme(_theme);
    }
  }, [_theme]);

  useEffect(() => {
    if (theme.steps) {
      const gallery =
        theme.steps.etapa_escolha_de_estilo.propriedades.conteudo.galeria;
      setGALLERY_COLUMN1(
        Object.values(gallery).slice(0, Object.values(gallery).length / 2)
      );
      setGALLERY_COLUMN2(
        Object.values(gallery).slice(
          Object.values(gallery).length / 2,
          Object.values(gallery).length
        )
      );
    }
  }, [theme]);

  const { token, updateTheme } = useContext(DataUserContext);

  const [imagesSelected, setImagesSelected] = useState<string[]>([]);
  const { next } = useContext(NavigateButtonsContext);

  const [requirementsFulfilled, setRequirementsFulfilled] =
    useState<boolean>(false);

  const [error, setError] = useState(0);

  function handleGalleryItemSelect(_galleryItemId: string) {
    if (
      imagesSelected.some((galleryItemId) => galleryItemId === _galleryItemId)
    ) {
      const index = imagesSelected.indexOf(_galleryItemId);
      if (index > -1) {
        const arrayWithoutRef = [...imagesSelected];
        arrayWithoutRef.splice(index, 1);
        setImagesSelected(arrayWithoutRef);
      }
    } else {
      if (imagesSelected.length < 5) {
        setImagesSelected((prevState) => [...prevState, _galleryItemId]);
      }
    }
  }

  useEffect(() => {
    HistoryPages.emit(eventTypes.SAVE, 3);
  }, []);

  useEffect(() => {
    if (imagesSelected.length >= 1) setRequirementsFulfilled(true);
    else setRequirementsFulfilled(false);
  }, [imagesSelected]);

  function submit() {
    if (requirementsFulfilled) {
      sendSelectedImages(
        imagesSelected
          .filter((id) => id !== undefined && id !== null)
          .map((id) => /\d+$/g.exec(id)![0])
          .map((id) => parseInt(id)),
        token
      )
        .then((response) => {
          updateTheme((prevTheme) => {
            const theme = prevTheme;
            theme.steps.etapa_apresentacao_de_estilo.propriedades.conteudo.estilo =
              response.estilo;

            return theme;
          });
        })
        .catch((error) => alert(error.response.data.message));

      next(4);
    } else {
      setError((prevState) => prevState + 1);
    }
  }

  return (
    <>
      {theme.status === "success" && (
        <Container>
          <Hero
            criare
            image={can(
              theme,
              "theme.steps.etapa_escolha_de_estilo.propriedades.imagens.etapa_escolha_de_estilo_imagemBanner.url"
            )}
            title={can(
              theme,
              "theme.steps.etapa_escolha_de_estilo.propriedades.banner.tituloBanner"
            )}
            superscript={can(
              theme,
              "theme.steps.etapa_escolha_de_estilo.propriedades.banner.subtituloBanner"
            )}
          />

          <Section>
            <p>
              {can(
                theme,
                "theme.steps.etapa_escolha_de_estilo. propriedades.conteudo.titulo"
              )}
            </p>
            <p>Marque até 5 ambientes!</p>

            <Gallery>
              <div className="column">
                {GALLERY_COLUMN1.map(({ url, id }) => (
                  <GalleryItem
                    isVisible={imagesSelected.some(
                      (galleryItemId) => galleryItemId === `column1-${id}`
                    )}
                    key={id}
                  >
                    <input
                      type="checkbox"
                      id={`column1-${id}`}
                      onClick={() => handleGalleryItemSelect(`column1-${id}`)}
                    />

                    <label htmlFor={`column1-${id}`}>
                      <img src={url} alt="" />
                      {!imagesSelected.some(
                        (galleryItemId) => galleryItemId === `column1-${id}`
                      ) && (
                        <div className="onhover">
                          <img src={url} alt="" />
                        </div>
                      )}
                      <div className="onSelect">
                        <div className="POC">
                          <img src={Icon3} alt="" className="check-icon" />
                        </div>
                      </div>
                    </label>
                  </GalleryItem>
                ))}
              </div>

              <div className="column">
                {GALLERY_COLUMN2.map(({ url, id }) => (
                  <GalleryItem
                    isVisible={imagesSelected.some(
                      (galleryItemId) => galleryItemId === `column2-${id}`
                    )}
                    key={id}
                  >
                    <input
                      type="checkbox"
                      id={`column2-${id}`}
                      onClick={() => handleGalleryItemSelect(`column2-${id}`)}
                    />

                    <label htmlFor={`column2-${id}`}>
                      <img src={url} alt="" />
                      {!imagesSelected.some(
                        (galleryItemId) => galleryItemId === `column2-${id}`
                      ) && (
                        <div className="onhover">
                          <img src={url} alt="" />
                        </div>
                      )}
                      <div className="onSelect">
                        <div className="POC">
                          <img src={Icon3} alt="" className="check-icon" />
                        </div>
                      </div>
                    </label>
                  </GalleryItem>
                ))}
              </div>
            </Gallery>
          </Section>

          <NavigateButtons>
            <Back criare onClick={() => next(HistoryPages.getLastPage())} />
            <Next criare onClick={submit} animationTrigger={error} />
          </NavigateButtons>

          <LinearGradient />
        </Container>
      )}
    </>
  );
};

export default Question02;
